import { AppDispatch } from "stateManagement/store";

// Import all API slices to access their util.resetApiState method
import { apiAttorneysSlice } from "services/attorneys/attorneysApi";
import { apiDealsSlice } from "services/deals/dealsApi";
import { apiEmployeesSlice } from "services/employees/employeesApi";
import { apiFiltersSlice } from "services/filters/filtersApi";
import { apiFirmSlice } from "services/firm/firmApi";
import { apiImpersonateSlice } from "services/impersonate/impersonateApi";
import { apiJobSlice } from "services/job/jobApi";
import { apiJobsSlice } from "services/jobs/jobsApi";
import { apiLitigationSlice } from "services/litigation/litigationApi";
import { apiReleaseNotesSlice } from "services/release-notes/releaseNotesApi";

// V2 API imports
import { admissionApi } from "services/v2/admissions/admissionApi";
import { attorneyConnectionApi } from "services/v2/attorney-connections/attorneyConnectionApi";
import { attorneyDownloadsApi } from "services/v2/attorney-downloads/attorneyDownloadsApi";
import { attorneyNotesApi } from "services/v2/attorney-notes/attorneyNotesApi";
import { attorneyApi } from "services/v2/attorneys/attorneyApi";
import { candidateNotesApi } from "services/v2/candidate-notes/candidateNotesApi";
import { candidateManagementApi } from "services/v2/candidates-management/candidateManagementApi";
import { candidatesApi } from "services/v2/candidates/candidatesApi";
import { cityApi } from "services/v2/cities/cityApi";
import { apiDealsV2Slice } from "services/v2/deals/dealsApi";
import { employeeApi } from "services/v2/employees/employeeApi";
import { apiEmployerAnaliticsSlice } from "services/v2/employer-analitics/employerAnaliticsApi";
import { employerApi } from "services/v2/employers/employerApi";
import { excludedFirmsApi } from "services/v2/excluded-firms/excludedFirmsApi";
import { honorApi } from "services/v2/honors/honorApi";
import { industryApi } from "services/v2/industries/industryApi";
import { jobNotesApi } from "services/v2/job-notes/jobNotesApi";
import { jobApi } from "services/v2/jobs/jobApi";
import { languageApi } from "services/v2/languages/languageApi";
import { apiLitigationV2Slice } from "services/v2/litigation/litigationApi";
import { officeApi } from "services/v2/offices/officeApi";
import { practiceAreaApi } from "services/v2/practice-areas/practiceAreaApi";
import { practiceTypeApi } from "services/v2/practice-types/practiceTypeApi";
import { apiPublicSlice as apiPublicV2Slice } from "services/v2/public/publicApi";
import { savedSearchesApi } from "services/v2/saved-searches/savedSearchesApi";
import { schoolApi } from "services/v2/schools/schoolApi";
import { specialtyApi } from "services/v2/specialties/specialtyApi";
import { titleApi } from "services/v2/titles/titleApi";

/**
 * Clears all RTK Query caches to prevent stale data from previous firm
 * when impersonating another firm. This ensures fresh data will be fetched
 * for the new firm context.
 */
export const clearAllApiCaches = (dispatch: AppDispatch) => {
  // V1 API slices
  dispatch(apiFiltersSlice.util.resetApiState());
  dispatch(apiFirmSlice.util.resetApiState());
  dispatch(apiAttorneysSlice.util.resetApiState());
  dispatch(apiJobsSlice.util.resetApiState());
  dispatch(apiJobSlice.util.resetApiState());
  dispatch(apiEmployeesSlice.util.resetApiState());
  dispatch(apiImpersonateSlice.util.resetApiState());
  dispatch(apiReleaseNotesSlice.util.resetApiState());
  dispatch(apiDealsSlice.util.resetApiState());
  dispatch(apiLitigationSlice.util.resetApiState());

  // V2 API slices - Core services
  dispatch(apiPublicV2Slice.util.resetApiState());
  dispatch(apiDealsV2Slice.util.resetApiState());
  dispatch(apiLitigationV2Slice.util.resetApiState());
  dispatch(apiEmployerAnaliticsSlice.util.resetApiState());

  // V2 API slices - Reference data services
  dispatch(practiceAreaApi.util.resetApiState());
  dispatch(specialtyApi.util.resetApiState());
  dispatch(industryApi.util.resetApiState());
  dispatch(practiceTypeApi.util.resetApiState());
  dispatch(titleApi.util.resetApiState());
  dispatch(officeApi.util.resetApiState());
  dispatch(schoolApi.util.resetApiState());
  dispatch(cityApi.util.resetApiState());
  dispatch(employeeApi.util.resetApiState());
  dispatch(admissionApi.util.resetApiState());
  dispatch(honorApi.util.resetApiState());
  dispatch(employerApi.util.resetApiState());
  dispatch(languageApi.util.resetApiState());

  // V2 API slices - Main entity services
  dispatch(attorneyApi.util.resetApiState());
  dispatch(jobApi.util.resetApiState());
  dispatch(candidatesApi.util.resetApiState());
  dispatch(candidateManagementApi.util.resetApiState());
  dispatch(attorneyConnectionApi.util.resetApiState());

  // V2 API slices - Notes services
  dispatch(savedSearchesApi.util.resetApiState());
  dispatch(attorneyNotesApi.util.resetApiState());
  dispatch(jobNotesApi.util.resetApiState());
  dispatch(candidateNotesApi.util.resetApiState());

  // V2 API slices - Additional services
  dispatch(excludedFirmsApi.util.resetApiState());
  dispatch(attorneyDownloadsApi.util.resetApiState());
};
